import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';

import { handleGetDrivers, restoreDrivers } from '../../../../store/actionCreators/drivers';

class Drivers extends Component {
    state = {
        getError: {
            state: false,
            message: ""
        },
    }
    
    componentDidMount() {
        this.props.dispatch(handleGetDrivers(this.props.match.params.id))
        .then(result => {
            if (result.error && result.error !== null) {
                this.setState({
                    getError: {
                        state: true,
                        message: result.error.message
                    }
                })
            } else {
            }
        })
    }
    
    componentWillUnmount() {
        this.props.dispatch(restoreDrivers())
    }
    
    render() {
        if (this.props.drivers && this.props.drivers !== null) {
            return (
                <div className="uni-supervisors p-2 py-lg-4 flex-grow-1">
                    <div className="pt-2 pb-2 px-3 m-1 m-lg-4 clearfix header-rec">
                        <h1 className="float-end">السائقين</h1>
                        <h1 className="float-start">3212</h1>
                    </div>
                    <div className="px-3">
                        <div className="position-relative">
                            <input type="text" className="search-input" placeholder="البحث بواسطة اسم السائق أو رقم هاتفه" />
                            <FiSearch className="search-icon" color="rgb(50,157,135)" size="2rem" />
                        </div>
                    </div>
                    <div className="supervisors py-3 d-flex flex-wrap align-content-start">
                        {this.props.drivers.map(driver => 
                            <div className="suber-card p-3 m-1 m-lg-3" key={driver._id}>
                                <div className="suber-card__header d-flex justify-content-between">
                                    <img src={driver.profile_photo} alt="Driver" width="70" height="70" />
                                </div>
                                <div className="mt-1">
                                    <h4>{driver.name}</h4>
                                    <h4>رقم الرخصة:</h4>
                                    <h4>{driver.driver_license}</h4>
                                </div>
                            </div>
                        )}
                        {/* <div className="suber-card p-3 m-1 m-lg-3 ">
                            <div className="suber-card__header d-flex justify-content-between">
                                <img src="/images/temp/A91brptgb_zle5b0_ask.jpg" alt="supervisor" width="70" height="70" />
                                <div>
                                    <button title="edit">
                                        <img className="m-1" src="/icons/edit.png" alt="edit" width="30" />
                                    </button>
                                    <button title="delete">
                                        <img className="m-1" src="/icons/trash.png" alt="delete" width="30" />
                                    </button>
                                </div>
                            </div>
                            <div className="mt-1">
                                <h4>محمد سمير المصري</h4>
                                <h4>رقم الرخصة</h4>
                                <h4>+962593496782</h4>
                            </div>
                        </div>
                        <div className="suber-card p-3 m-1 m-lg-3 ">
                            <div className="suber-card__header d-flex justify-content-between">
                                <img src="/images/temp/A91brptgb_zle5b0_ask.jpg" alt="supervisor" width="70" height="70" />
                                <div>
                                    <button title="edit">
                                        <img className="m-1" src="/icons/edit.png" alt="edit" width="30" />
                                    </button>
                                    <button title="delete">
                                        <img className="m-1" src="/icons/trash.png" alt="delete" width="30" />
                                    </button>
                                </div>
                            </div>
                            <div className="mt-1">
                                <h4>محمد سمير المصري</h4>
                                <h4>رقم الرخصة</h4>
                                <h4>+962593496782</h4>
                            </div>
                        </div> */}
                    </div>
                </div>
            )
        } else {
            if (this.state.getError.state) {
                return (
                    <div className="m-5">
                        <div className="alert alert-danger text-center mb-5 fs-5" role="alert">
                            {this.state.getError.message}
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className="text-center m-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )
            }
        }
    }
}

function mapStateToProps ({ drivers }) {
	return {
		drivers
	}
}

export default withRouter(connect(mapStateToProps)(Drivers));